function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Children, PureComponent } from 'react';
import PropTypes from 'prop-types';
import MenuOption from '../MenuOption';
/**
 *
 * - [MDN docs on optgroup](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/optgroup)
 *
 * ## Related Components
 * - [DropdownMenu](../DropdownMenu/README.md)
 * - [MenuOption](../MenuOption/README.md)
 */

var MenuGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(MenuGroup, _PureComponent);

  var _super = _createSuper(MenuGroup);

  function MenuGroup() {
    var _this;

    _classCallCheck(this, MenuGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "makeOptions", function () {
      var children = _this.props.children;
      return Children.toArray(children).map(_this.wrapOption);
    });

    _defineProperty(_assertThisInitialized(_this), "wrapOption", function (el, index) {
      var _this$props = _this.props,
          qa = _this$props.qa,
          onOption = _this$props.onOption,
          allDisabled = _this$props.disabled,
          optionType = _this$props.optionType;
      var _el$props = el.props,
          value = _el$props.value,
          disabled = _el$props.disabled,
          alert = _el$props.alert,
          primaryText = _el$props.primaryText,
          secondaryText = _el$props.secondaryText,
          tertiaryText = _el$props.tertiaryText,
          iconType = _el$props.iconType;

      var isSelected = _this.isSelected(value);

      return /*#__PURE__*/React.createElement(MenuOption, _extends({}, el.props, {
        className: "psw-fill-x",
        qa: "".concat(qa, "#option-").concat(index),
        key: value,
        value: value,
        iconType: iconType,
        selected: isSelected,
        disabled: allDisabled || disabled,
        alert: alert,
        primaryText: primaryText,
        secondaryText: secondaryText,
        tertiaryText: tertiaryText,
        variant: optionType,
        onClick: onOption
      }));
    });

    return _this;
  }

  _createClass(MenuGroup, [{
    key: "isSelected",
    value: function isSelected(optionValue) {
      var value = this.props.value;
      return value === optionValue;
    }
  }, {
    key: "render",
    value: function render() {
      return this.makeOptions();
    }
  }]);

  return MenuGroup;
}(PureComponent);

MenuGroup.defaultProps = {
  qa: '',
  onOption: function onOption() {},
  value: null,
  disabled: false,
  optionType: 'selection',
  iconType: null
};
MenuGroup.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Whether the options are disabled
   */
  disabled: PropTypes.bool,

  /**
   * The list of MenuOptions
   */
  children: PropTypes.node.isRequired,

  /**
   * Function to call when option item is clicked
   */
  onOption: PropTypes.func,

  /**
   * The currently selected value
   */
  value: PropTypes.oneOfType([PropTypes.string]),

  /*
  * sets the type of dropdown Menu
  */
  optionType: PropTypes.string,

  /**
    * String of the icon type to be shown in the cta
    */
  iconType: PropTypes.string
};
export default MenuGroup;